import { Component, OnInit } from '@angular/core';
import { UserService } from "../../../service/user.service";

declare var $:any;
@Component({
  selector: 'app-notifications',
  templateUrl: './notifications.component.html',
  styleUrls: ['./notifications.component.css']
})
export class NotificationsComponent implements OnInit {

  constructor(private _userSerice : UserService) { }

  emailNotifications = { activity : false , messages : false, posts: false, events: false
                        ,maintenance: false, recommendations: false, marketplace: false};

  successMsg = false;
  
  buildingAlerts = [
    {
       name : "Text Alerts",
       slug : "text",
       desc : "Recieve alerts through text message (SMS)",
       value : false
    },
    {
       name : "Email Alerts",
       slug : "email",
       desc : "Recieve alerts through Email (SMS)",
       value : false
    },
    {
       name : "Text and Email Alerts",
       slug : "textemail",
       desc : "Recieve alerts through text message (SMS) and Email",
       value : false
    }
  ];

  ngOnInit() {

     this._userSerice.getSettings().subscribe((res) => {
       
        if(res.settings){
          var buildingNotify = res.settings.notifications.buildingNotify;
          var emailNotify = res.settings.notifications.emailNotify;
          
          if(emailNotify){
              this.emailNotifications = emailNotify;
          }

          if(buildingNotify){
              this.buildingAlerts.forEach(function callback(alert, index, array) {
                  alert.value = false;
                  for (var i=0; i<buildingNotify.length; i++) {
                    if(buildingNotify[i].slug == alert.slug && buildingNotify[i].value == true){
                        alert.value = true;
                    }
                  }             
              });
          }
        }
     });

  }

  toggleFeedOpt(optEle, opt){
      if(opt === 'activity'){
        $(optEle).find('.toggled_wrap').toggleClass('active');      
      }else if(opt !== 'activity' && this.emailNotifications.activity === true){
        $(optEle).find('.toggled_wrap').toggleClass('active');
      }
      
        var state = $(optEle).find('div').first()[0].className;
        this.updateState(state, opt);


  }

  updateState(state, opt){

    switch(opt) {
        case 'posts':

            if(state === 'toggled_wrap active'){
                this.emailNotifications.posts = true; 
            }else{
                this.emailNotifications.posts = false;  
            }
           
            break;
        case 'events':
            if(state === 'toggled_wrap active'){
                this.emailNotifications.events = true; 
            }else{
                this.emailNotifications.events = false;  
            }
            break;
        case 'maintenance':
            if(state === 'toggled_wrap active'){
                this.emailNotifications.maintenance = true; 
            }else{
                this.emailNotifications.maintenance = false;  
            }
            break;

        case 'recommendations':
            if(state === 'toggled_wrap active'){
                this.emailNotifications.recommendations = true; 
            }else{
                this.emailNotifications.recommendations = false;  
            }
            break;
            
        case 'marketplace':
            if(state === 'toggled_wrap active'){
                this.emailNotifications.marketplace = true; 
            }else{
                this.emailNotifications.marketplace = false;  
            }
            break;

        case 'activity':
            if(state === 'toggled_wrap active'){
                this.emailNotifications.activity = true; 
                this.emailNotifications.activity = true; 
                this.emailNotifications.events = true;
                this.emailNotifications.posts = true;
                this.emailNotifications.recommendations = true;
                this.emailNotifications.maintenance = true;
                this.emailNotifications.marketplace = true;
            }else{
                this.emailNotifications.activity = false; 
                this.emailNotifications.events = false;
                this.emailNotifications.posts = false;
                this.emailNotifications.recommendations = false;
                this.emailNotifications.maintenance = false;
                this.emailNotifications.marketplace = false;
            }
            break;
        default:
            
    }
  }

  toggleMsgOpt(optEle, type=null){
     
     $(optEle).find('.toggled_wrap').toggleClass('active');
     
     var activeClass = $(optEle).find('.toggled_wrap.active');
     if(activeClass.length > 0){
         this.emailNotifications.messages = true;
     }else{
        this.emailNotifications.messages = false;
     }

  }

  saveSettings(){
     //console.log(this.emailNotifications);
     //console.log(this.buildingAlerts);
     var settings = {
       page : 'notifications',
       emailNotify : this.emailNotifications,
       buildingNotify : this.buildingAlerts
     }
     this._userSerice.saveNotificationSettings(settings).subscribe((res) => {
         if(res.success==true){
            this.successMsg = true;

            setTimeout(()=>{
                this.successMsg = false;
            },2000);

         }
     });
  }

  alertRadio(slug){
      
      this.buildingAlerts.forEach(function callback(alert, index, array) {
           alert.value = false;
           if(alert.slug == slug){
               alert.value = true;
           }             
      });
  }
}
